import { useLang } from "@/i18n";

export default function Marquee() {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-white/10 bg-[#050a16]/80 py-5"
    >
      <div className="marquee-track flex w-max items-center">
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-mono-accent text-xs sm:text-sm uppercase tracking-[0.3em] text-slate-400 whitespace-nowrap px-8">
              {item}
            </span>
            <span className="text-cyan-400/70 text-sm">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
